import {isEqual} from 'lodash';

export default {
    computed: {
        exitConfirmationRequired() {
            return !isEqual(this.initialStepState, this.currentStepState);
        },
    },
};
